import React from 'react';
import { Row, Col, Button, Table } from 'react-bootstrap';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { omit as _omit } from 'lodash';
import moment from 'moment';
import 'moment-timezone';

import { changeUploadContext, resetUploadContext } from 'actions/UploadActions';
import { addNotification } from 'actions/NotificationsActions';

import SimplePrompt from 'components/layout/SimplePrompt';

import ClientLocationDetails from 'components/layout/client/ClientLocationDetails';

import { ROLE_CRM_MASTER } from 'js/constants';
import may from 'js/security';

class ClientLocations extends React.Component {
  constructor(props) {
    super(props);

    moment.locale(globalLocale);

    this.state = {
      shownIndex: null,
    };
  }

  handleClick = index => {
    this.setState(prevState => ({ shownIndex: index === prevState.shownIndex ? null : index }));

    if (false) {
    } else {
      const { entity, updateUploadContext } = this.props;

      updateUploadContext({
        type: 'companyLocation_img',
        locationId: entity.getLocations()[index].getId(),
        uploadLink:
          '/api/clients/' +
          entity.getUsername() +
          '/locations/' +
          entity.getLocations()[index].getId() +
          '/assets.json',
      });
    }
  };

  componentWillUnmount = () => {
    const { doResetUploadContext } = this.props;
    doResetUploadContext();
  };

  closeDetails = () => {
    this.setState({ shownIndex: null });
  };

  addLocation = () => {
    const { entity, changeEntity } = this.props;
    const newLocation = entity.createValue('locations', []);
    const newValue = entity.getLocations().slice();
    newValue.push(newLocation);
    const newEntity = { ...entity.updateValue('locations', newValue, []) };

    this.setState({ shownIndex: newValue.length - 1 });

    changeEntity(newEntity);
  };

  handleRemoveClick = (e, index) => {
    e.preventDefault();
    e.stopPropagation();

    this.removeEntry(index);
  };

  removeEntry = index => {
    const { entity, changeEntity } = this.props;
    const newValue = entity.getLocations().slice();
    newValue.splice(index, 1);
    const newEntity = { ...entity.updateValue('locations', newValue, []) };

    if (index < this.state.shownIndex) {
      this.setState(
        prevState => ({ shownIndex: prevState.shownIndex - 1 }),
        () => {
          changeEntity(newEntity);
        }
      );
    } else if (index === this.state.shownIndex) {
      this.setState({ shownIndex: null }, () => {
        changeEntity(newEntity);
      });
    } else {
      changeEntity(newEntity);
    }
  };

  duplicateLocation = (e, index) => {
    e.preventDefault();
    e.stopPropagation();

    const { entity, changeEntity } = this.props;

    let data = entity.copyObject(entity.getLocations()[index]);
    data = _omit(data, ['imgs']);

    let newLocation = entity.createValue('locations', [], data);
    let newValue = entity.getLocations().slice();
    newValue.splice(index + 1, 0, newLocation);
    let newEntity = { ...entity.updateValue('locations', newValue, []) };

    changeEntity(newEntity, () => {
      this.setState({ shownIndex: index + 1 });
    });
  };

  render() {
    const { intl, entityLoaded, entity, changeEntity, disabled, user } = this.props;
    const { shownIndex } = this.state;
    const messages = intl.messages;

    const columns = [messages.name, messages.address, messages.zip_code, messages.city, messages.actions];
    let tBody = [];
    if (entityLoaded && entity.getLocations().length) {
      const locations = entity.getLocations();
      tBody = locations.map((location, i) => {
        return (
          <tr
            key={i}
            class={(i === shownIndex ? 'shown ' : '') + (i % 2 ? 'even ' : 'odd ')}
            onClick={() => {
              this.handleClick(i);
            }}
          >
            <td class="v-align-middle semi-bold">{location.getName()}</td>
            <td class="v-align-middle">
              {location.getStreet()} {location.getHouseNumber()}
            </td>
            <td class="v-align-middle">{location.getZipCode()}</td>
            <td class="v-align-middle">{location.getCity()}</td>
            <td class="v-align-middle text-right">
              {i === shownIndex ? (
                <Button bsSize="sm" class="btn-rounded m-r-10">
                  <i class="fa fa-times" /> {messages.close}
                </Button>
              ) : (
                <Button bsSize="sm" class="btn-rounded m-r-10">
                  <i class="fa fa-pencil-alt" /> {messages.edit}
                </Button>
              )}
              <Button
                bsSize="sm"
                class="btn-rounded m-r-10"
                onClick={e => {
                  this.duplicateLocation(e, i);
                }}
              >
                <i class="fa fa-files-o" /> {messages.duplicate}
              </Button>
              {may(ROLE_CRM_MASTER, user.roles) && (
                <SimplePrompt
                  onSuccess={e => {
                    this.handleRemoveClick(e, i);
                  }}
                />
              )}
            </td>
          </tr>
        );
      });
    }

    if (shownIndex !== null) {
      const data = entity.getLocations()[shownIndex];

      // user wants to see a location form
      tBody.splice(
        shownIndex + 1,
        0,
        <ClientLocationDetails
          key={'details-showing-' + shownIndex}
          entityLoaded={entityLoaded}
          entity={entity}
          changeEntity={changeEntity}
          disabled={disabled}
          user={user}
          data={data}
          colSpan={columns.length}
          shownIndex={shownIndex}
          timezone={this.props.timezone}
        />
      );
    }

    return (
      <div class="clearfix padding-20 sm-padding-10">
        {entityLoaded ? (
          <Row>
            <Col xs={12}>
              <Table responsive hover class="table-detailed">
                <thead>
                  <tr>
                    {columns.map((column, i) => {
                      return (
                        <th key={i} class={column === messages.actions ? 'text-right' : ''}>
                          {column}
                        </th>
                      );
                    })}
                  </tr>
                </thead>
                <ReactCSSTransitionGroup
                  transitionName="tablerows"
                  transitionEnterTimeout={500}
                  transitionLeaveTimeout={1}
                  component="tbody"
                >
                  {tBody}
                </ReactCSSTransitionGroup>
              </Table>

              <div class="m-t-10">
                <Button onClick={this.addLocation}>{messages.add_location}</Button>
              </div>
            </Col>
          </Row>
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.login.user,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    updateUploadContext: newContext => {
      dispatch(changeUploadContext(newContext));
    },
    doResetUploadContext: () => {
      dispatch(resetUploadContext());
    },
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
  };
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ClientLocations)
);
